export default __webpack_public_path__ + "a74ce0eb93acc8290aa62c22fa5a5d1f.png";